import { makeStyles } from '@material-ui/core/styles'
import { headerHeight, leftSidebarWidth, leftSidebarToolsWidth } from '../../Constants'

export const leftSideBarStyle = makeStyles((theme) => ({
  root: {
    width: leftSidebarWidth,
    height: `calc(100vh - ${headerHeight}px)`,
    background: theme.palette.common.white
  },
  tools: {
    position: 'absolute',
    height: `calc(100vh - ${headerHeight}px)`,
    zIndex: 100,
    right: -leftSidebarToolsWidth,
    top: 0,
    width: leftSidebarToolsWidth,
    background: theme.palette.geoColors.toolBar.dark
  },
  tool: {
    width: leftSidebarToolsWidth,
    color: theme.palette.common.white,
    fontSize: '1.3rem'
  },
  toolDisabled: {
    width: leftSidebarToolsWidth,
    fontSize: '1.3rem',
    color: theme.palette.geoColors.contextBar.dark
  },
  toolSelected: {
    width: leftSidebarToolsWidth,
    fontSize: '1.3rem',
    color: theme.palette.primary.main,
    stroke: theme.palette.geoColors.toolBar.light,
    strokeWidth: 25
  },
  toolSelectedMaterial: {
    width: leftSidebarToolsWidth,
    fontSize: '1.3rem',
    color: theme.palette.primary.main,
    stroke: theme.palette.geoColors.toolBar.light,
    strokeWidth: 0.7
  },
  virtualBoreholeIcon: {
    fontSize: '2rem'
  }
}))
